import { render, staticRenderFns } from "./homeServiceCommissionList.vue?vue&type=template&id=668e6b7c&"
import script from "./homeServiceCommissionList.vue?vue&type=script&lang=js&"
export * from "./homeServiceCommissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports